const STORAGE_KEY = "nm_about_content";
const DEFAULT_IMAGE = "/img/employee-01.jpg";

const TEAM_KEYS = ["leaders", "marketing", "designers", "production"];

const TEAM_TITLES = {
  leaders: "Руководители компании",
  marketing: "Команда маркетинга",
  designers: "Команда дизайнеров",
  production: "Команда производства",
};

const DEFAULT_DESCRIPTION = {
  title: "Компания НОВАЯ МАРКА предоставляет широкий спектр услуг по изготовлению рекламы в Пензе и в регионах России",
  paragraph1:
    "Рекламно-производственная компания «Новая Марка». Мы делаем вывески, полиграфию и сувенирную продукцию. На рынке более 15 лет. Имеем выполненные проекты в 30 регионах России и портфолио успешной работы с 17 компаниями из ТОП 100 в списке Forbes.",
  paragraph2:
    "Компания «Новая Марка» с 2003 года предоставляет широкий спектр услуг в сфере производства рекламы. Каждый год мы решаем сложные задачи. Развиваемся вместе с нашими клиентами.",
};

const DEFAULT_ACHIEVEMENTS = [
  { value: "20", label: "лет безупречного опыта" },
  { value: ">10 800", label: "выполненных рекламных проектов" },
  { value: "17", label: "компаний из ТОП-Forbes нам доверяют" },
];

const DEFAULT_PERSON = {
  id: "1",
  name: "Юрий Калинин",
  post: "Основатель компании",
  shortDesc: "В рекламе с 1991 года.",
  description:
    "Генеральный директор компании «Новая Марка» Юрий Евгеньевич Калинин. В рекламе с 1991 года. Является основателем рекламного рынка в Пензе, создателем первого в Пензе рекламного агентства «Аншлаг» и до середины 90-х фактически монополистом на рекламном рынке Пензы.\n\nБыл президентом Пензенского отделения ассоциации рекламных агентств России, председателем комитета по рекламе при Торгово-промышленной палате.\n\nОсновные компетенции: управление рекламным агентством, консалтинг, брендинг, разработка стратегии.",
  image: DEFAULT_IMAGE,
};

const DEFAULT_HISTORY = [
  {
    id: "h1",
    year: "2023",
    title: "Развитие компании",
    text: "В 1990 году учебное заведение переименовали в автошколу ПСА, среди пензенцев старшего поколения более известна, как «Московская 25», расположенная по одноименному адресу.\n\nКомпания продолжает развиваться и реализовывать проекты по всей России.",
    link: "#",
    linkText: "Проект",
  },
];

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function createId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

function getDefaultData() {
  return {
    description: { ...DEFAULT_DESCRIPTION },
    achievements: DEFAULT_ACHIEVEMENTS.map((item) => ({ ...item })),
    teamTitles: { ...TEAM_TITLES },
    teams: {
      leaders: [{ ...DEFAULT_PERSON }],
      marketing: [],
      designers: [],
      production: [],
    },
    history: DEFAULT_HISTORY.map((item) => ({ ...item })),
  };
}

function normalizeTeamTitles(rawTitles) {
  const source = rawTitles && typeof rawTitles === "object" ? rawTitles : {};
  const next = {};
  TEAM_KEYS.forEach((key) => {
    const value = String(source[key] || TEAM_TITLES[key] || "").trim();
    next[key] = value || TEAM_TITLES[key];
  });
  return next;
}

function getTeamTitle(key, data) {
  const source = data || getAboutData();
  const titles = source?.teamTitles && typeof source.teamTitles === "object"
    ? source.teamTitles
    : TEAM_TITLES;
  const value = String(titles[key] || TEAM_TITLES[key] || key).trim();
  return value || TEAM_TITLES[key] || key;
}

function formatTeamHeadingHtml(title) {
  const words = String(title || "").trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "";
  if (words.length === 1) return `<span>${escapeHtml(words[0])}</span>`;
  return `<span>${escapeHtml(words[0])}</span> ${escapeHtml(words.slice(1).join(" "))}`;
}

function normalizePerson(person = {}) {
  return {
    id: String(person.id || createId()),
    name: String(person.name || "").trim(),
    post: String(person.post || "").trim(),
    shortDesc: String(person.shortDesc || "").trim(),
    description: String(person.description || "").trim(),
    image: String(person.image || DEFAULT_IMAGE).trim() || DEFAULT_IMAGE,
  };
}

function normalizeHistoryItem(item = {}) {
  return {
    id: String(item.id || createId()),
    year: String(item.year || "").trim(),
    title: String(item.title || "").trim(),
    text: String(item.text || "").trim(),
    link: String(item.link || "#").trim() || "#",
    linkText: String(item.linkText || "Проект").trim() || "Проект",
  };
}

function normalizeAchievement(item = {}, fallback = {}) {
  return {
    value: String(item.value || fallback.value || "").trim(),
    label: String(item.label || fallback.label || "").trim(),
  };
}

function normalizeTeamList(list, fallback) {
  if (!Array.isArray(list)) return fallback.map((item) => ({ ...item }));
  return list.map(normalizePerson).filter((item) => item.name);
}

function normalizeData(raw) {
  const fallback = getDefaultData();
  if (!raw || typeof raw !== "object") return fallback;

  const description = raw.description && typeof raw.description === "object"
    ? {
      title: String(raw.description.title || fallback.description.title),
      paragraph1: String(raw.description.paragraph1 || fallback.description.paragraph1),
      paragraph2: String(raw.description.paragraph2 || fallback.description.paragraph2),
    }
    : { ...fallback.description };

  const achievementsSource = Array.isArray(raw.achievements) ? raw.achievements : fallback.achievements;
  const achievements = fallback.achievements.map((item, index) => (
    normalizeAchievement(achievementsSource[index], item)
  ));

  const rawTeams = raw.teams && typeof raw.teams === "object" ? raw.teams : {};
  const teams = {
    leaders: normalizeTeamList(
      rawTeams.leaders || raw.leaders,
      fallback.teams.leaders,
    ),
    marketing: normalizeTeamList(rawTeams.marketing, fallback.teams.marketing),
    designers: normalizeTeamList(rawTeams.designers, fallback.teams.designers),
    production: normalizeTeamList(rawTeams.production, fallback.teams.production),
  };

  const teamTitles = normalizeTeamTitles(raw.teamTitles);

  const history = Array.isArray(raw.history)
    ? raw.history.map(normalizeHistoryItem).filter((item) => item.year || item.title || item.text)
    : fallback.history.map((item) => ({ ...item }));

  return {
    description,
    achievements,
    teamTitles,
    teams,
    history,
  };
}

function getAboutData() {
  const cached = window.NMApi?.cache?.about;
  if (cached) return normalizeData(cached);
  return getDefaultData();
}

function saveAboutData(data) {
  const normalized = normalizeData(data);
  if (window.NMApi) {
    window.NMApi.cache.about = normalized;
    window.NMApi.save("about", normalized).catch((error) => {
      window.alert(error.message || "Не удалось сохранить страницу «О компании»"); // eslint-disable-line no-alert
    });
  }
  return normalized;
}

function descriptionToHtml(text) {
  const chunks = String(text || "")
    .split(/\n{2,}/)
    .map((chunk) => chunk.trim())
    .filter(Boolean);

  if (!chunks.length) {
    return "<p>Описание пока не добавлено.</p>";
  }

  return chunks
    .map((chunk) => `<p>${escapeHtml(chunk).replace(/\n/g, "<br>")}</p>`)
    .join("");
}

function highlightTitle(title) {
  const safe = escapeHtml(title);
  return safe
    .replace(/НОВАЯ МАРКА/g, "<span>НОВАЯ МАРКА</span>")
    .replace(/спектр услуг/g, "<span>спектр услуг</span>")
    .replace(/рекламы/g, "<span>рекламы</span>");
}

function findPersonById(data, id) {
  return TEAM_KEYS
    .map((key) => data.teams[key].find((item) => item.id === id))
    .find(Boolean);
}

function fillEmployeePopup(person) {
  const popup = document.getElementById("popup-employee");
  if (!popup || !person) return;

  const img = popup.querySelector(".popup-employee__img img");
  const name = popup.querySelector(".popup-employee__name");
  const post = popup.querySelector(".popup-employee__post");
  const shortDesc = popup.querySelector(".popup-employee__desc");
  const content = popup.querySelector(".popup-employee__content .user-content");

  if (img) {
    img.src = person.image || DEFAULT_IMAGE;
    img.alt = person.name || "Сотрудник";
  }
  if (name) name.textContent = person.name || "";
  if (post) post.textContent = person.post || "";
  if (shortDesc) shortDesc.textContent = person.shortDesc || "";
  if (content) content.innerHTML = descriptionToHtml(person.description);
}

function renderTeamTitles(teamTitles) {
  TEAM_KEYS.forEach((key) => {
    const node = document.querySelector(`[data-about-team-title="${key}"]`);
    if (!node) return;
    const title = String(teamTitles?.[key] || TEAM_TITLES[key] || "").trim() || TEAM_TITLES[key];
    node.innerHTML = formatTeamHeadingHtml(title);
  });
}

function renderTeam(teamKey, people) {
  const wrapper = document.querySelector(`[data-about-team="${teamKey}"]`);
  if (!wrapper) return;

  if (!people.length) {
    wrapper.innerHTML = `
      <div class="slide-row__slide swiper-slide">
        <div class="employee-preview">
          <div class="employee-preview__wrapper">
            <div class="employee-preview__content">
              <div class="employee-preview__name h5">Пока нет карточек</div>
              <div class="employee-preview__post d2">Добавьте сотрудников в разделе «Контент»</div>
            </div>
          </div>
        </div>
      </div>
    `;
    return;
  }

  wrapper.innerHTML = people.map((person) => `
    <div class="slide-row__slide swiper-slide">
      <div class="employee-preview" data-about-person-id="${escapeHtml(person.id)}">
        <div class="employee-preview__wrapper">
          <div class="employee-preview__img">
            <img src="${escapeHtml(person.image || DEFAULT_IMAGE)}" alt="${escapeHtml(person.name)}" width="280" height="280">
          </div>
          <div class="employee-preview__content">
            <div class="employee-preview__name h5">${escapeHtml(person.name)}</div>
            <div class="employee-preview__post d2">${escapeHtml(person.post)}</div>
          </div>
        </div>
      </div>
    </div>
  `).join("");

  wrapper.querySelectorAll("[data-about-person-id]").forEach((card) => {
    card.addEventListener("click", (event) => {
      event.preventDefault();
      const id = card.getAttribute("data-about-person-id");
      const person = people.find((item) => item.id === id);
      fillEmployeePopup(person);
      if (typeof window.openPopup === "function") {
        window.openPopup("popup-employee");
      }
    });
  });
}

function renderDescription(description) {
  const root = document.querySelector(".about-page .location-section");
  if (!root || !description) return;

  const title = root.querySelector(".location-section__title");
  const paragraphs = root.querySelectorAll(".location-section__desc");

  if (title) {
    title.innerHTML = highlightTitle(description.title);
  }

  if (paragraphs[0]) paragraphs[0].textContent = description.paragraph1;
  if (paragraphs[1]) paragraphs[1].textContent = description.paragraph2;
}

function renderAchievements(achievements) {
  const root = document.querySelector(".about-page .location-section");
  if (!root || !Array.isArray(achievements)) return;

  const nodes = root.querySelectorAll(".location-section__achievement");
  nodes.forEach((node, index) => {
    const item = achievements[index];
    if (!item) return;
    const value = node.querySelector(".location-section__achievement-value");
    const label = node.querySelector(".location-section__achievement-desc");
    if (value) value.textContent = item.value;
    if (label) label.textContent = item.label;
  });
}

function renderHistory(history) {
  const wrapper = document.querySelector("[data-about-history]");
  if (!wrapper) return;

  if (!history.length) {
    wrapper.innerHTML = `
      <div class="history-section__slide swiper-slide">
        <div class="history-block">
          <div class="history-block__wrapper">
            <div class="history-block__year h2">—</div>
            <div class="history-block__content">
              <div class="user-content">
                <p>Добавьте события истории в разделе «Контент».</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    return;
  }

  wrapper.innerHTML = history.map((item) => `
    <div class="history-section__slide swiper-slide">
      <div class="history-block">
        <div class="history-block__wrapper">
          <div class="history-block__year h2">${escapeHtml(item.year || "—")}</div>
          <div class="history-block__content">
            <div class="user-content">
              ${item.title ? `<h5>${escapeHtml(item.title)}</h5>` : ""}
              ${descriptionToHtml(item.text)}
            </div>
            ${(() => {
    const href = window.NMSanitize?.safeHref?.(item.link) || "";
    if (!href) return "";
    return `
              <a class="history-block__btn btn btn_l" href="${escapeHtml(href)}">
                <span>${escapeHtml(item.linkText || "Проект")}</span>
                <svg width="72" height="32" viewBox="0 0 72 32">
                  <use xlink:href="#icon-arrow-long"></use>
                </svg>
              </a>
            `;
  })()}
          </div>
        </div>
      </div>
    </div>
  `).join("");
}

let aboutHydrated = false;
function hydrateAboutPage() {
  if (!document.querySelector(".about-page") || aboutHydrated) return;
  aboutHydrated = true;

  const data = getAboutData();
  renderDescription(data.description);
  renderAchievements(data.achievements);
  renderTeamTitles(data.teamTitles);
  TEAM_KEYS.forEach((key) => renderTeam(key, data.teams[key]));
  renderHistory(data.history);

  const firstPerson = TEAM_KEYS
    .map((key) => data.teams[key][0])
    .find(Boolean);
  if (firstPerson) fillEmployeePopup(firstPerson);

  window.setTimeout(() => {
    window.reinitAboutSwipers?.();
  }, 0);
}

window.NMAboutContent = {
  STORAGE_KEY,
  DEFAULT_IMAGE,
  TEAM_KEYS,
  TEAM_TITLES,
  createId,
  escapeHtml,
  getAboutData,
  saveAboutData,
  getDefaultData,
  getTeamTitle,
  formatTeamHeadingHtml,
  normalizePerson,
  normalizeLeader: normalizePerson,
  normalizeHistoryItem,
  descriptionToHtml,
  findPersonById,
};

window.NMApi?.ready?.then(hydrateAboutPage);
